/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: f4e204f33aa2
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * The code indicating the result of the operation.
 */
export const Code = {
  RejectedIds: "rejected_ids",
  InvalidIds: "invalid_ids",
  InternalErrorIds: "internal_error_ids",
  NonExistingIds: "non_existing_ids",
  InvalidRelateToSelfId: "invalid_relate_to_self_id",
  AlreadyExistsIds: "already_exists_ids",
  RelationDoesNotExistIds: "relation_does_not_exist_ids",
  SuccessIds: "success_ids",
} as const;
/**
 * The code indicating the result of the operation.
 */
export type Code = ClosedEnum<typeof Code>;

export const Code$zodSchema = z.enum([
  "rejected_ids",
  "invalid_ids",
  "internal_error_ids",
  "non_existing_ids",
  "invalid_relate_to_self_id",
  "already_exists_ids",
  "relation_does_not_exist_ids",
  "success_ids",
]).describe("The code indicating the result of the operation.");

export type AssetRelationInfo = {
  message?: string | undefined;
  code?: Code | undefined;
  asset?: string | undefined;
  status?: number | undefined;
};

export const AssetRelationInfo$zodSchema: z.ZodType<AssetRelationInfo> = z
  .object({
    asset: z.string().optional().describe(
      "The identifier of the asset, either asset ID or public ID path.",
    ),
    code: Code$zodSchema.optional().describe(
      "The code indicating the result of the operation.",
    ),
    message: z.string().optional().describe(
      "The message indicating the result of the operation.",
    ),
    status: z.int().optional().describe(
      "The HTTP status code indicating the result of the operation.",
    ),
  });
